export function clearPath(path) {
  if (typeof path !== 'string') return path
  // if 'ua' or 'ru' is in the url, it will be removed
  return path.replace(/^\/[a-z]{2}(\/|$)/, '/')
}
